import apiRequest from "src/utils/api-request";
import withApiPath from "src/utils/with-api-path";

export interface TreasuryPosition {
	currency: string;
	blockchain: string;
	networkId: string;
	held: string;
	owed: string;
	inFlight: string;
	withdrawable: string;
	heldUsd?: string;
	owedUsd?: string;
	inFlightUsd?: string;
	withdrawableUsd?: string;
}

export interface TreasurySummary {
	positions: TreasuryPosition[];
	totalHeldUsd: string;
	totalOwedUsd: string;
	totalWithdrawableUsd: string;
}

const treasuryProvider = {
	async getSummary(): Promise<TreasurySummary> {
		const response = await apiRequest.get<TreasurySummary>(
			withApiPath("/treasury"),
		);
		return response.data;
	},
};

export default treasuryProvider;
